(() => {
  const formatPrice = (value, config) => {
    let digits = String(Math.round(value));

    if (config.separator) {
      digits = digits.replace(/\B(?=(\d{3})+(?!\d))/g, config.separator);
    }

    let money = digits;
    if (config.symbol) {
      money = config.position === 'before' ? config.symbol + digits : digits + ' ' + config.symbol;
    }

    return config.prefix ? config.prefix + ' ' + money : money;
  };

  const initConfigurator = (root) => {
    if (!root || root.dataset.pcReady === 'true') return;
    root.dataset.pcReady = 'true';

    const output = root.querySelector('[data-pc-total]');
    if (!output) return;

    const config = {
      symbol: root.dataset.symbol || '',
      position: root.dataset.position || 'after',
      separator: root.dataset.separator || '',
      prefix: root.dataset.prefix || '',
    };

    const basePrice = parseFloat(root.dataset.basePrice) || 0;
    const options = root.querySelectorAll('[data-pc-option]');
    const sizes = root.querySelectorAll('[data-pc-size]');

    // Con bloques de tamaño, el precio base lo fija el tamaño seleccionado.
    const getBasePrice = () => {
      if (!sizes.length) return basePrice;
      const selected = root.querySelector('[data-pc-size]:checked');
      return selected ? parseFloat(selected.dataset.price) || 0 : 0;
    };

    const update = () => {
      let total = getBasePrice();

      options.forEach((option) => {
        if (option.checked) total += parseFloat(option.dataset.price) || 0;
      });

      output.textContent = formatPrice(total, config);
    };

    options.forEach((option) => option.addEventListener('change', update));
    sizes.forEach((size) => size.addEventListener('change', update));

    update();
  };

  const initAll = () => {
    document.querySelectorAll('[data-price-configurator]').forEach(initConfigurator);
  };

  document.addEventListener('shopify:section:load', initAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
